'use client'
import React from 'react'

import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'
import { createPortal } from 'react-dom'

// Need to track of the latest instance because, due to pages animations,
// the previous nesting disappears 0.6s after the new one is mounted.

let currentInstance = 0
let rootPortalNodeStore = atom<{ node: HTMLElement; instance: number } | null>(null)

export const RootPortalNesting = () => {
  const instanceIdRef = React.useRef(currentInstance++)
  const handleNestingRef = React.useCallback((node: HTMLElement | null) => {
    if (node) rootPortalNodeStore.set({ node, instance: instanceIdRef.current })
  }, [])
  React.useEffect(
    () => () => {
      if (rootPortalNodeStore.get()?.instance === instanceIdRef.current) {
        rootPortalNodeStore.set(null)
      }
    },
    [],
  )
  return <div ref={handleNestingRef} />
}

export const RootPortal = ({ children }: { children: React.ReactNode }) => {
  const rootPortal = useStore(rootPortalNodeStore)
  if (!rootPortal) return null
  const { node } = rootPortal
  return createPortal(children, node)
}
